import { motion } from "framer-motion";
import { X, Check, ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "./motion";
import { BEFORE_AFTER } from "../config/content";

export default function BeforeAfter() {
  return (
    <section className="py-16 md:py-24 bg-[#0B110D]" data-testid="before-after-section">
      <div className="max-w-[1180px] mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>{BEFORE_AFTER.eyebrow}</Eyebrow>
          <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl leading-none tracking-wide" data-testid="before-after-heading">
            <span className="text-[#EF4444]">BEFORE</span> AND <span className="text-[#22C55E]">AFTER</span> MARUBAZU
          </h2>
        </Reveal>
        <div className="mt-10 grid md:grid-cols-2 gap-4 md:gap-6">
          <div className="rounded-2xl bg-[#EF4444]/[0.05] border border-[#EF4444]/25 p-6 sm:p-8" data-testid="before-column">
            <h3 className="font-heading uppercase text-[#EF4444] text-2xl tracking-wide mb-6">{BEFORE_AFTER.beforeLabel}</h3>
            <div className="space-y-4">
              {BEFORE_AFTER.rows.map(([before], i) => (
                <motion.div
                  key={before}
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                  className="flex items-center gap-3"
                >
                  <X className="w-5 h-5 text-[#EF4444] shrink-0" strokeWidth={3} />
                  <p className="text-sm sm:text-base text-[#A7B3AA]">{before}</p>
                </motion.div>
              ))}
            </div>
          </div>
          <div className="rounded-2xl bg-[#22C55E]/[0.05] border border-[#22C55E]/30 p-6 sm:p-8 shadow-[0_0_50px_-18px_rgba(34,197,94,0.35)]" data-testid="after-column">
            <h3 className="font-heading uppercase text-[#22C55E] text-2xl tracking-wide mb-6">{BEFORE_AFTER.afterLabel}</h3>
            <div className="space-y-4">
              {BEFORE_AFTER.rows.map(([, after], i) => (
                <motion.div
                  key={after}
                  initial={{ opacity: 0, x: 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                  className="flex items-center gap-3"
                >
                  <Check className="w-5 h-5 text-[#22C55E] shrink-0" strokeWidth={3} />
                  <p className="text-sm sm:text-base text-white">{after}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
        <Reveal className="mt-8 hidden md:flex justify-center">
          <div className="flex items-center gap-3 text-[#6B7A70] text-sm">
            <span>Trading alone</span>
            <ArrowRight className="w-4 h-4 text-[#22C55E]" />
            <span className="text-white">Trading with a system</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
